// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Zu8mjbQVnZUSGUvm {
  max-width: 1310px;
  margin: 0px auto;
  padding-bottom: 96px;
}

.Zu8mjbQVnZUSGUvm h2 {
  color: #303030;
  font-size: 30px;
  font-weight: 600;
  margin: 0;
}

.Q6cbRs2aWGgQ1ulq {
  margin: 45px 0 30px 0;
}

.vrrbUSFWAx0DVpfz {
  color: #000000;
  background-color: transparent;
  border: none;
}

.vrrbUSFWAx0DVpfz i {
  font-size: 16px;
  background-color: #f2e1bc;
  padding: 10px;
  border-radius: 8px;
  margin-left: 12px;
}

.Zu8mjbQVnZUSGUvm .p-datatable-table {
  border-radius: 16px;
  overflow: hidden;
}

.Zu8mjbQVnZUSGUvm .p-datatable-thead th {
  background-color: #f2e1bc;
  border: 1px solid #f3f5f7;
  padding: 18px 30px;
}

.Zu8mjbQVnZUSGUvm .p-datatable-thead th:first-child > div {
  display: flex;
  justify-content: flex-start;
}

.Zu8mjbQVnZUSGUvm .p-datatable-thead th > div {
  display: flex;
  justify-content: center;
  color: #303030;
  font-size: 18px;
}

.Zu8mjbQVnZUSGUvm .p-datatable-tbody td {
  border: 1px solid #f3f5f7;
  padding: 9px 8px;
}

.Zu8mjbQVnZUSGUvm .p-datatable-tbody tr td:first-child {
  text-align: left;
}

.Zu8mjbQVnZUSGUvm .p-datatable-tbody tr .UEUKxfUuO3kvJZmh {
  display: flex;
  justify-content: center;
  align-items: center;
}

.Ddy2XK9_j8oGR7xt {
  background-size: cover;
  height: 50px;
  width: 71px;
  background-color: gray;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  overflow: hidden;
}

.Ddy2XK9_j8oGR7xt i {
  display: none;
}

.Zu8mjbQVnZUSGUvm .p-datatable-tbody tr:hover .Ddy2XK9_j8oGR7xt i {
  display: block;
}

.Zu8mjbQVnZUSGUvm .p-datatable-tbody tr:hover .Ddy2XK9_j8oGR7xt div {
  width: 100%;
  height: 100%;
  background-color: #2e2e2e55;
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
}

.Zu8mjbQVnZUSGUvm .p-datatable-tbody tr td {
  text-align: center;
}

.Zu8mjbQVnZUSGUvm .p-datatable-tbody tr:hover .yVmJB9ruTowXLetI {
  background-color: #e1e7ed;
}

.yVmJB9ruTowXLetI {
  padding: 28px 22px;
  border-radius: 6px;
}

.ckN_hQU78q02E1dz {
  display: flex;
  gap: 8px;
}

.V6N4j7q5dZ4K9OWU,
.pbDlk1r_4OgolG3K,
.FWYxGtNgXmMtjmln {
  width: 75px;
  height: 67px;
}

.Zu8mjbQVnZUSGUvm .p-datatable-tbody tr:hover .V6N4j7q5dZ4K9OWU {
  background-color: #c5f3c1;
}

.Zu8mjbQVnZUSGUvm .p-datatable-tbody tr:hover .pbDlk1r_4OgolG3K {
  background-color: #e1e7ed;
}

.Zu8mjbQVnZUSGUvm .p-datatable-tbody tr:hover .FWYxGtNgXmMtjmln {
  background-color: #ffcaca;
}

.V6N4j7q5dZ4K9OWU span::before {
  color: #56be4d;
  font-size: 20px;
}

.FWYxGtNgXmMtjmln span::before {
  color: #dd0000;
  font-size: 20px;
}

.Zu8mjbQVnZUSGUvm .p-datatable-tbody tr:hover .V6N4j7q5dZ4K9OWU span::before {
  color: #185625;
}

.Zu8mjbQVnZUSGUvm .p-datatable-tbody tr:hover .pbDlk1r_4OgolG3K span::before {
  color: #20336c;
}

.pbDlk1r_4OgolG3K span::before {
  color: #4d87be;
  font-size: 20px;
}

.OGdMexyFACMyJ27d {
  width: 114px;
  height: 67px;
}

.VpiCsKxQYKxZGpQG {
  width: 100%;
}

.VpiCsKxQYKxZGpQG > span {
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #4d87be;
  border-radius: 16px;
  padding: 14px 0px;
  font-size: 18px;
  font-weight: 600;
}

.VpiCsKxQYKxZGpQG > span:hover {
  background-color: #20336C;
}

.VpiCsKxQYKxZGpQG > span > span {
  width: fit-content;
  flex-grow: 0;
}

.Zu8mjbQVnZUSGUvm .p-datatable-tbody tr:hover .OGdMexyFACMyJ27d {
  background-color: #e1e7ed;
}

.hDWBOyZSJHwUvQoa {
  display: inline-block;
}

.gzIEcOLjj6EDEyIn {
  background-color: #f2efea;
  padding: 20px;
  display: flex;
  justify-content: center;
}

.mwSH0QfFMgokgPgB {
  width: 250px;
  height: 250px;
  border-radius: 54px;
  overflow: hidden;
}

.mwSH0QfFMgokgPgB ._cibfz4iAIhAArgH {
  height: 173px;
  background-color: gray;
  background-size: cover;
}

.mwSH0QfFMgokgPgB .aqbjGvBUMMKDKRo0 {
  height: 77px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  font-size: 16px;
  font-family: "Roboto";
  background-color: #ffffff;
  padding: 0 8px;
  text-align: center;
  line-height: 1.2;
  word-break: break-word;
}

.Tj4m8GmnnN8xJp6C {
  border-radius: 16px;
  font-size: 18px;
  padding: 14px 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);
}

.d0faxKa839A7vu5O {
  background-color: #e1e7ed;
  border-radius: 16px;
  overflow: hidden;
}

.d0faxKa839A7vu5O .p-button {
  background-color: transparent;
  border: none;
  font-size: 20px;
  padding: 15px 0px;
}

.d0faxKa839A7vu5O .p-highlight {
  background-color: #4d87be;
  border-radius: 16px;
}

.BsCzD41u4_ICL5Ns {
  width: 100%;
  background-color: #56be4d;
  border-radius: 16px;
  padding: 18px 0px;
  color: #ffffff;
  border: none;
  font-size: 20px;
  font-weight: 600;
}

.BsCzD41u4_ICL5Ns:hover {
  background-color: #185625;
}

.lPmFzIwzWAL182bQ {
  width: 42.125rem !important;
  height: fit-content !important;
  border-radius: 1rem !important;
}

.lPmFzIwzWAL182bQ .p-dialog-content {
  background-color: #F3F5F7;
  height: fit-content !important;
}

.lPmFzIwzWAL182bQ .p-dialog {
  border-radius: 1rem !important;
}

.lPmFzIwzWAL182bQ .p-dialog-header {
  background-color: #F3F5F7;
  border-top-right-radius: 1rem !important;
  border-top-left-radius: 1rem !important;
}

.lPmFzIwzWAL182bQ .p-dialog-footer {
  background-color: #F3F5F7;
  border-bottom-right-radius: 1rem !important;
  border-bottom-left-radius: 1rem !important;
}

.OgjWn4BVR34gajyi {
  width: 541px !important;
  height: 354px !important;
  background-color: #F3F5F7;
  border-radius: 25px !important;
}

.OgjWn4BVR34gajyi .p-dialog {
  border-radius: 25px !important;
  background-color: #F3F5F7;
}

.OgjWn4BVR34gajyi .p-dialog-footer {
  border-bottom-right-radius: 25px !important;
  border-bottom-left-radius: 25px !important;
  background-color: #F3F5F7;
}

.OgjWn4BVR34gajyi .p-dialog-header {
  border-top-right-radius: 25px !important;
  border-top-left-radius: 25px !important;
  background-color: #F3F5F7;
}

.OgjWn4BVR34gajyi .p-dialog-content{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.OgjWn4BVR34gajyi .CesXH2fAcmUO71Ds {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 20px;
  font-weight: 400;
}

.OgjWn4BVR34gajyi .p-dialog-title {
  font-size: 30px !important;
  font-weight: 700 !important;
}

.OgjWn4BVR34gajyi .p-dialog-content {
  background-color: #F3F5F7;
}

.gvreoiQh2rUDGmXi {
  width: 100%;
  background-color: #DD0000;
  border-radius: 16px;
  padding: 18px 20px;
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  border: none;
}

.gvreoiQh2rUDGmXi:hover {
  background-color: #721010;
}

.Llni_zjHaSopug5W {
  width: 100%;
  background-color: #F3F5F7;
  border-radius: 16px;
  padding: 10px 20px;
  color: #4D87BE;
  font-size: 20px;
  font-weight: 600;
  border: none;
}

.Llni_zjHaSopug5W:hover {
  color: #305375;
}

.yDNAdgH445c9d_fW {
  width: 37.75rem;
  height: fit-content !important;
  background-color: #F3F5F7;
  border-radius: 1rem !important;
}

.yDNAdgH445c9d_fW .p-dialog {
  border-radius: 1rem !important;
}

.yDNAdgH445c9d_fW .p-dialog-header {
  background-color: #F3F5F7;
  border-top-right-radius: 1rem !important;
  border-top-left-radius: 1rem !important;
}

.yDNAdgH445c9d_fW .p-dialog-content {
  background-color: #F3F5F7;
}

.yDNAdgH445c9d_fW .p-dialog-footer {
  background-color: #F3F5F7;
  border-bottom-right-radius: 1rem !important;
  border-bottom-left-radius: 1rem !important;
}

.V8Sbzzuy7RIoDw8T {
  width: 37.75rem;
  height: fit-content !important;
  background-color: #F3F5F7;
  border-radius: 1rem !important;
}

.V8Sbzzuy7RIoDw8T .gzIEcOLjj6EDEyIn {
  background-color: #F3F5F7;
}

.V8Sbzzuy7RIoDw8T .p-dialog {
  border-radius: 1rem !important;
}

.V8Sbzzuy7RIoDw8T .p-dialog-header {
  background-color: #F3F5F7;
  border-top-right-radius: 1rem !important;
  border-top-left-radius: 1rem !important;
}

.V8Sbzzuy7RIoDw8T .p-dialog-content {
  background-color: #F3F5F7;
}

.V8Sbzzuy7RIoDw8T .p-dialog-footer {
  background-color: #F3F5F7;
  border-bottom-right-radius: 1rem !important;
  border-bottom-left-radius: 1rem !important;
}

.lPmFzIwzWAL182bQ .p-dialog-title {
  font-size: 1.875rem !important;
  font-weight: 700 !important;
}

.OgjWn4BVR34gajyi .p-dialog-title {
  font-size: 1.875rem !important;
  font-weight: 700 !important;
}

.yDNAdgH445c9d_fW .p-dialog-title {
  font-size: 1.875rem !important;
  font-weight: 700 !important;
}

.lPmFzIwzWAL182bQ .field label {
  font-size: 1.25rem !important;
  font-weight: 400 !important;
}

.B_zRwsfsC5IPbaxn {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.RYH1L3hdTMT6p3tF {
  background: #ffffff;
  padding: 20px;
  border-radius: 8px;
  min-height: 63px;
  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.PI2jUnLMM9McuymH {
  background-size: cover;
  min-width: 80px !important;
  min-height: 67px !important;
  background-color: gray;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  overflow: hidden;
}

.iGobeldEhSIgJqNh {
  display: flex;
  flex-direction: row;
}

.iGobeldEhSIgJqNh .HbLtahDfdkkTanzg {
  display: flex;
  flex-direction: column;
  margin-left: 8px;
}

.ia4dr1BuGv8VuYCx {
  font-weight: 500;
  color: #303030;
  font-size: 14px;
}

.ieqlz0jH1mM_dEk9 {
  color: #888888;
  font-weight: 400;
  font-size: 12px;
}

.SZZX4SZjeUS5aH9E {
  display: flex;
  gap: 12px;
}

.Waw4CNcHHMqKudnh {
  color: #1976d2;
  background: none;
  border: none;
}

.A6H1Z5OH8Us30RTT {
  color: #d32f2f;
  background: none;
  border: none;
  font-size: 20px;
}

.Waw4CNcHHMqKudnh i::before,
.A6H1Z5OH8Us30RTT i::before {
  font-size: 16px;
}

@media screen and (max-width: 1267px) {
  .Zu8mjbQVnZUSGUvm .p-datatable .p-datatable-thead > tr > th,
  .Zu8mjbQVnZUSGUvm .p-datatable .p-datatable-tfoot > tr > td {
    display: none !important;
  }
  
  .Zu8mjbQVnZUSGUvm .p-datatable .p-datatable-tbody > tr {
    display: flex;
    flex-direction: row;
  }
  
  .Zu8mjbQVnZUSGUvm .p-datatable .p-datatable-tbody > tr > td:not(:last-child) {
    border: 0 none;
  }
  
  .Zu8mjbQVnZUSGUvm .p-datatable .p-datatable-tbody > tr > td:not(:first-child) {
    width: fit-content !important;
  }
  
  .Zu8mjbQVnZUSGUvm .p-datatable .p-datatable-tbody > tr > td {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between !important;
    padding: 0;
    margin: 0;
  }
  
  .Zu8mjbQVnZUSGUvm .p-datatable .p-datatable-tbody > tr > td > .p-column-title {
    display: block;
  }
  
  .Zu8mjbQVnZUSGUvm .p-datatable-tbody td {
    border: 1px solid #f3f5f7;
    padding: 6px 4px;
  }
}

@media screen and (max-width: 1221px) {
  .yVmJB9ruTowXLetI {
    padding: 14px 11px;
    border-radius: 6px;
  }
}

@media screen and (max-width: 1024px) {
  .Zu8mjbQVnZUSGUvm .p-datatable .p-datatable-tbody > tr > td:not(:first-child) {
    width: 100% !important;
  }
}

@media screen and (max-width: 425px) {
  .Q6cbRs2aWGgQ1ulq {
    margin: 45px 0 8px 0;
  }
  
  .Q6cbRs2aWGgQ1ulq h2 {
    font-size: 20px;
    font-weight: 700;
  }
  
  .Q6cbRs2aWGgQ1ulq button {
    padding: 0;
  }
  
  .Q6cbRs2aWGgQ1ulq button > span {
    display: none;
  }
  
  .Q6cbRs2aWGgQ1ulq button > i {
    margin-left: 0;
    width: 100%;
  }
  
  .OgjWn4BVR34gajyi,
  .lPmFzIwzWAL182bQ {
    width: 350px !important;
  }
  
  .lPmFzIwzWAL182bQ .field label {
    font-size: 14px !important;
  }
  
  .yDNAdgH445c9d_fW .p-dialog-title,
  .OgjWn4BVR34gajyi .p-dialog-title,
  .lPmFzIwzWAL182bQ .p-dialog-title {
    font-size: 20px !important;
    font-weight: 700 !important;
  }
  
  .OgjWn4BVR34gajyi .CesXH2fAcmUO71Ds {
    font-size: 16px;
  }
  
  .Tj4m8GmnnN8xJp6C {
    font-size: 14px;
    padding: 14px 20px;
    background-color: #ffffff;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);
  }
  
  .BsCzD41u4_ICL5Ns {
    padding: 14px 0;
    font-size: 16px;
  }
  
  .gvreoiQh2rUDGmXi {
    border-radius: 8px;
    padding: 14px 16px;
    font-size: 16px;
  }
  
  .Llni_zjHaSopug5W {
    border-radius: 8px;
    padding: 10px 20px;
    font-size: 16px;
  }
  
  .d0faxKa839A7vu5O {
    background-color: #e1e7ed;
    border-radius: 8px;
    overflow: hidden;
  }
  
  .d0faxKa839A7vu5O .p-button {
    background-color: transparent;
    border: none;
    font-size: 16px;
    font-weight: 500;
    padding: 15px 0;
  }
  
  .d0faxKa839A7vu5O .p-highlight {
    background-color: #4d87be;
    border-radius: 8px;
  }
  
  .yDNAdgH445c9d_fW {
    width: 350px;
  }
  
  .yDNAdgH445c9d_fW p {
    font-size: 14px;
    text-align: center;
  }
  
  .VpiCsKxQYKxZGpQG > span {
    font-size: 16px;
  }
  
  .mwSH0QfFMgokgPgB {
    width: 160px;
    height: 160px;
    border-radius: 30px;
  }
  
  .mwSH0QfFMgokgPgB ._cibfz4iAIhAArgH {
    height: 105px;
  }
  
  .mwSH0QfFMgokgPgB .aqbjGvBUMMKDKRo0 {
    height: 60px;
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Manager/components/Stations.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;;EAGE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,sGAAsG;AACxG;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gDAAgD;EAChD,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,yCAAyC;IACzC,UAAU;IACV,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,sGAAsG;EACxG;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".pageWrapper {\r\n  max-width: 1310px;\r\n  margin: 0px auto;\r\n  padding-bottom: 96px;\r\n}\r\n\r\n.pageWrapper h2 {\r\n  color: #303030;\r\n  font-size: 30px;\r\n  font-weight: 600;\r\n  margin: 0;\r\n}\r\n\r\n.header {\r\n  margin: 45px 0 30px 0;\r\n}\r\n\r\n.createBtn {\r\n  color: #000000;\r\n  background-color: transparent;\r\n  border: none;\r\n}\r\n\r\n.createBtn i {\r\n  font-size: 16px;\r\n  background-color: #f2e1bc;\r\n  padding: 10px;\r\n  border-radius: 8px;\r\n  margin-left: 12px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-table) {\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th) {\r\n  background-color: #f2e1bc;\r\n  border: 1px solid #f3f5f7;\r\n  padding: 18px 30px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th:first-child > div) {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th > div) {\r\n  display: flex;\r\n  justify-content: center;\r\n  color: #303030;\r\n  font-size: 18px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody td) {\r\n  border: 1px solid #f3f5f7;\r\n  padding: 9px 8px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr td:first-child) {\r\n  text-align: left;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr) .cellImageWrapper {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.imageCell {\r\n  background-size: cover;\r\n  height: 50px;\r\n  width: 71px;\r\n  background-color: gray;\r\n  color: #ffffff;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n}\r\n\r\n.imageCell i {\r\n  display: none;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .imageCell i {\r\n  display: block;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .imageCell div {\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: #2e2e2e55;\r\n  backdrop-filter: blur(2px);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 6px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr td) {\r\n  text-align: center;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .cellInsider {\r\n  background-color: #e1e7ed;\r\n}\r\n\r\n.cellInsider {\r\n  padding: 28px 22px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.cellSoundWrapper {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.playBtn,\r\n.soundBtn,\r\n.deleteBtn {\r\n  width: 75px;\r\n  height: 67px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .playBtn {\r\n  background-color: #c5f3c1;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .soundBtn {\r\n  background-color: #e1e7ed;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .deleteBtn {\r\n  background-color: #ffcaca;\r\n}\r\n\r\n.playBtn span::before {\r\n  color: #56be4d;\r\n  font-size: 20px;\r\n}\r\n\r\n.deleteBtn span::before {\r\n  color: #dd0000;\r\n  font-size: 20px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .playBtn span::before {\r\n  color: #185625;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .soundBtn span::before {\r\n  color: #20336c;\r\n}\r\n\r\n.soundBtn span::before {\r\n  color: #4d87be;\r\n  font-size: 20px;\r\n}\r\n\r\n.activeBtn {\r\n  width: 114px;\r\n  height: 67px;\r\n}\r\n\r\n.uploadBtn {\r\n  width: 100%;\r\n}\r\n\r\n.uploadBtn > span {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  background-color: #4d87be;\r\n  border-radius: 16px;\r\n  padding: 14px 0px;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n}\r\n\r\n.uploadBtn > span:hover {\r\n  background-color: #20336C;\r\n}\r\n\r\n.uploadBtn > span > span {\r\n  width: fit-content;\r\n  flex-grow: 0;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .activeBtn {\r\n  background-color: #e1e7ed;\r\n}\r\n\r\n.cardWrapper {\r\n  display: inline-block;\r\n}\r\n\r\n.preview {\r\n  background-color: #f2efea;\r\n  padding: 20px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.stationCard {\r\n  width: 250px;\r\n  height: 250px;\r\n  border-radius: 54px;\r\n  overflow: hidden;\r\n}\r\n\r\n.stationCard .image {\r\n  height: 173px;\r\n  background-color: gray;\r\n  background-size: cover;\r\n}\r\n\r\n.stationCard .titleWrapper {\r\n  height: 77px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-transform: uppercase;\r\n  font-size: 16px;\r\n  font-family: \"Roboto\";\r\n  background-color: #ffffff;\r\n  padding: 0 8px;\r\n  text-align: center;\r\n  line-height: 1.2;\r\n  word-break: break-word;\r\n}\r\n\r\n.input {\r\n  border-radius: 16px;\r\n  font-size: 18px;\r\n  padding: 14px 20px;\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.selectButton {\r\n  background-color: #e1e7ed;\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n}\r\n\r\n.selectButton :global(.p-button) {\r\n  background-color: transparent;\r\n  border: none;\r\n  font-size: 20px;\r\n  padding: 15px 0px;\r\n}\r\n\r\n.selectButton :global(.p-highlight) {\r\n  background-color: #4d87be;\r\n  border-radius: 16px;\r\n}\r\n\r\n.saveBtn {\r\n  width: 100%;\r\n  background-color: #56be4d;\r\n  border-radius: 16px;\r\n  padding: 18px 0px;\r\n  color: #ffffff;\r\n  border: none;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n}\r\n\r\n.saveBtn:hover {\r\n  background-color: #185625;\r\n}\r\n\r\n.stationModal {\r\n  width: 42.125rem !important;\r\n  height: fit-content !important;\r\n  border-radius: 1rem !important;\r\n}\r\n\r\n.stationModal :global(.p-dialog-content) {\r\n  background-color: #F3F5F7;\r\n  height: fit-content !important;\r\n}\r\n\r\n.stationModal :global(.p-dialog) {\r\n  border-radius: 1rem !important;\r\n}\r\n\r\n.stationModal :global(.p-dialog-header) {\r\n  background-color: #F3F5F7;\r\n  border-top-right-radius: 1rem !important;\r\n  border-top-left-radius: 1rem !important;\r\n}\r\n\r\n.stationModal :global(.p-dialog-footer) {\r\n  background-color: #F3F5F7;\r\n  border-bottom-right-radius: 1rem !important;\r\n  border-bottom-left-radius: 1rem !important;\r\n}\r\n\r\n.deleteModal {\r\n  width: 541px !important;\r\n  height: 354px !important;\r\n  background-color: #F3F5F7;\r\n  border-radius: 25px !important;\r\n}\r\n\r\n.deleteModal :global(.p-dialog) {\r\n  border-radius: 25px !important;\r\n  background-color: #F3F5F7;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-footer) {\r\n  border-bottom-right-radius: 25px !important;\r\n  border-bottom-left-radius: 25px !important;\r\n  background-color: #F3F5F7;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-header) {\r\n  border-top-right-radius: 25px !important;\r\n  border-top-left-radius: 25px !important;\r\n  background-color: #F3F5F7;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-content){\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n}\r\n\r\n.deleteModal .text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  font-size: 20px;\r\n  font-weight: 400;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-title) {\r\n  font-size: 30px !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-content) {\r\n  background-color: #F3F5F7;\r\n}\r\n\r\n.deleteDialogBtn {\r\n  width: 100%;\r\n  background-color: #DD0000;\r\n  border-radius: 16px;\r\n  padding: 18px 20px;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #ffffff;\r\n  border: none;\r\n}\r\n\r\n.deleteDialogBtn:hover {\r\n  background-color: #721010;\r\n}\r\n\r\n.cancelDialogBtn {\r\n  width: 100%;\r\n  background-color: #F3F5F7;\r\n  border-radius: 16px;\r\n  padding: 10px 20px;\r\n  color: #4D87BE;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  border: none;\r\n}\r\n\r\n.cancelDialogBtn:hover {\r\n  color: #305375;\r\n}\r\n\r\n.imageModal {\r\n  width: 37.75rem;\r\n  height: fit-content !important;\r\n  background-color: #F3F5F7;\r\n  border-radius: 1rem !important;\r\n}\r\n\r\n.imageModal :global(.p-dialog) {\r\n  border-radius: 1rem !important;\r\n}\r\n\r\n.imageModal :global(.p-dialog-header) {\r\n  background-color: #F3F5F7;\r\n  border-top-right-radius: 1rem !important;\r\n  border-top-left-radius: 1rem !important;\r\n}\r\n\r\n.imageModal :global(.p-dialog-content) {\r\n  background-color: #F3F5F7;\r\n}\r\n\r\n.imageModal :global(.p-dialog-footer) {\r\n  background-color: #F3F5F7;\r\n  border-bottom-right-radius: 1rem !important;\r\n  border-bottom-left-radius: 1rem !important;\r\n}\r\n\r\n.soundModal {\r\n  width: 37.75rem;\r\n  height: fit-content !important;\r\n  background-color: #F3F5F7;\r\n  border-radius: 1rem !important;\r\n}\r\n\r\n.soundModal .preview {\r\n  background-color: #F3F5F7;\r\n}\r\n\r\n.soundModal :global(.p-dialog) {\r\n  border-radius: 1rem !important;\r\n}\r\n\r\n.soundModal :global(.p-dialog-header) {\r\n  background-color: #F3F5F7;\r\n  border-top-right-radius: 1rem !important;\r\n  border-top-left-radius: 1rem !important;\r\n}\r\n\r\n.soundModal :global(.p-dialog-content) {\r\n  background-color: #F3F5F7;\r\n}\r\n\r\n.soundModal :global(.p-dialog-footer) {\r\n  background-color: #F3F5F7;\r\n  border-bottom-right-radius: 1rem !important;\r\n  border-bottom-left-radius: 1rem !important;\r\n}\r\n\r\n.stationModal :global(.p-dialog-title) {\r\n  font-size: 1.875rem !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-title) {\r\n  font-size: 1.875rem !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.imageModal :global(.p-dialog-title) {\r\n  font-size: 1.875rem !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.stationModal :global(.field) label {\r\n  font-size: 1.25rem !important;\r\n  font-weight: 400 !important;\r\n}\r\n\r\n.cardList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.cardItem {\r\n  background: #ffffff;\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  min-height: 63px;\r\n  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  position: relative;\r\n}\r\n\r\n.cardImage {\r\n  background-size: cover;\r\n  min-width: 80px !important;\r\n  min-height: 67px !important;\r\n  background-color: gray;\r\n  color: #ffffff;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n}\r\n\r\n.cardInfo {\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n\r\n.cardInfo .info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-left: 8px;\r\n}\r\n\r\n.name {\r\n  font-weight: 500;\r\n  color: #303030;\r\n  font-size: 14px;\r\n}\r\n\r\n.subfield {\r\n  color: #888888;\r\n  font-weight: 400;\r\n  font-size: 12px;\r\n}\r\n\r\n.actions {\r\n  display: flex;\r\n  gap: 12px;\r\n}\r\n\r\n.cardEditBtn {\r\n  color: #1976d2;\r\n  background: none;\r\n  border: none;\r\n}\r\n\r\n.cardDeleteBtn {\r\n  color: #d32f2f;\r\n  background: none;\r\n  border: none;\r\n  font-size: 20px;\r\n}\r\n\r\n.cardEditBtn i::before,\r\n.cardDeleteBtn i::before {\r\n  font-size: 16px;\r\n}\r\n\r\n@media screen and (max-width: 1267px) {\r\n  .pageWrapper :global(.p-datatable .p-datatable-thead > tr > th),\r\n  .pageWrapper :global(.p-datatable .p-datatable-tfoot > tr > td) {\r\n    display: none !important;\r\n  }\r\n  \r\n  .pageWrapper :global(.p-datatable .p-datatable-tbody > tr) {\r\n    display: flex;\r\n    flex-direction: row;\r\n  }\r\n  \r\n  .pageWrapper :global(.p-datatable .p-datatable-tbody > tr > td:not(:last-child)) {\r\n    border: 0 none;\r\n  }\r\n  \r\n  .pageWrapper :global(.p-datatable .p-datatable-tbody > tr > td:not(:first-child)) {\r\n    width: fit-content !important;\r\n  }\r\n  \r\n  .pageWrapper :global(.p-datatable .p-datatable-tbody > tr > td) {\r\n    display: flex;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-content: space-between !important;\r\n    padding: 0;\r\n    margin: 0;\r\n  }\r\n  \r\n  .pageWrapper :global(.p-datatable .p-datatable-tbody > tr > td > .p-column-title) {\r\n    display: block;\r\n  }\r\n  \r\n  .pageWrapper :global(.p-datatable-tbody td) {\r\n    border: 1px solid #f3f5f7;\r\n    padding: 6px 4px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1221px) {\r\n  .cellInsider {\r\n    padding: 14px 11px;\r\n    border-radius: 6px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1024px) {\r\n  .pageWrapper :global(.p-datatable .p-datatable-tbody > tr > td:not(:first-child)) {\r\n    width: 100% !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 425px) {\r\n  .header {\r\n    margin: 45px 0 8px 0;\r\n  }\r\n  \r\n  .header h2 {\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n  }\r\n  \r\n  .header button {\r\n    padding: 0;\r\n  }\r\n  \r\n  .header button > span {\r\n    display: none;\r\n  }\r\n  \r\n  .header button > i {\r\n    margin-left: 0;\r\n    width: 100%;\r\n  }\r\n  \r\n  .deleteModal,\r\n  .stationModal {\r\n    width: 350px !important;\r\n  }\r\n  \r\n  .stationModal :global(.field) label {\r\n    font-size: 14px !important;\r\n  }\r\n  \r\n  .imageModal :global(.p-dialog-title),\r\n  .deleteModal :global(.p-dialog-title),\r\n  .stationModal :global(.p-dialog-title) {\r\n    font-size: 20px !important;\r\n    font-weight: 700 !important;\r\n  }\r\n  \r\n  .deleteModal .text {\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .input {\r\n    font-size: 14px;\r\n    padding: 14px 20px;\r\n    background-color: #ffffff;\r\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);\r\n  }\r\n  \r\n  .saveBtn {\r\n    padding: 14px 0;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .deleteDialogBtn {\r\n    border-radius: 8px;\r\n    padding: 14px 16px;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .cancelDialogBtn {\r\n    border-radius: 8px;\r\n    padding: 10px 20px;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .selectButton {\r\n    background-color: #e1e7ed;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n  }\r\n  \r\n  .selectButton :global(.p-button) {\r\n    background-color: transparent;\r\n    border: none;\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    padding: 15px 0;\r\n  }\r\n  \r\n  .selectButton :global(.p-highlight) {\r\n    background-color: #4d87be;\r\n    border-radius: 8px;\r\n  }\r\n  \r\n  .imageModal {\r\n    width: 350px;\r\n  }\r\n  \r\n  .imageModal p {\r\n    font-size: 14px;\r\n    text-align: center;\r\n  }\r\n  \r\n  .uploadBtn > span {\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .stationCard {\r\n    width: 160px;\r\n    height: 160px;\r\n    border-radius: 30px;\r\n  }\r\n  \r\n  .stationCard .image {\r\n    height: 105px;\r\n  }\r\n  \r\n  .stationCard .titleWrapper {\r\n    height: 60px;\r\n    font-size: 14px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export var pageWrapper = `Zu8mjbQVnZUSGUvm`;
export var header = `Q6cbRs2aWGgQ1ulq`;
export var createBtn = `vrrbUSFWAx0DVpfz`;
export var cellImageWrapper = `UEUKxfUuO3kvJZmh`;
export var imageCell = `Ddy2XK9_j8oGR7xt`;
export var cellInsider = `yVmJB9ruTowXLetI`;
export var cellSoundWrapper = `ckN_hQU78q02E1dz`;
export var playBtn = `V6N4j7q5dZ4K9OWU`;
export var soundBtn = `pbDlk1r_4OgolG3K`;
export var deleteBtn = `FWYxGtNgXmMtjmln`;
export var activeBtn = `OGdMexyFACMyJ27d`;
export var uploadBtn = `VpiCsKxQYKxZGpQG`;
export var cardWrapper = `hDWBOyZSJHwUvQoa`;
export var preview = `gzIEcOLjj6EDEyIn`;
export var stationCard = `mwSH0QfFMgokgPgB`;
export var image = `_cibfz4iAIhAArgH`;
export var titleWrapper = `aqbjGvBUMMKDKRo0`;
export var input = `Tj4m8GmnnN8xJp6C`;
export var selectButton = `d0faxKa839A7vu5O`;
export var saveBtn = `BsCzD41u4_ICL5Ns`;
export var stationModal = `lPmFzIwzWAL182bQ`;
export var deleteModal = `OgjWn4BVR34gajyi`;
export var text = `CesXH2fAcmUO71Ds`;
export var deleteDialogBtn = `gvreoiQh2rUDGmXi`;
export var cancelDialogBtn = `Llni_zjHaSopug5W`;
export var imageModal = `yDNAdgH445c9d_fW`;
export var soundModal = `V8Sbzzuy7RIoDw8T`;
export var cardList = `B_zRwsfsC5IPbaxn`;
export var cardItem = `RYH1L3hdTMT6p3tF`;
export var cardImage = `PI2jUnLMM9McuymH`;
export var cardInfo = `iGobeldEhSIgJqNh`;
export var info = `HbLtahDfdkkTanzg`;
export var name = `ia4dr1BuGv8VuYCx`;
export var subfield = `ieqlz0jH1mM_dEk9`;
export var actions = `SZZX4SZjeUS5aH9E`;
export var cardEditBtn = `Waw4CNcHHMqKudnh`;
export var cardDeleteBtn = `A6H1Z5OH8Us30RTT`;
export default ___CSS_LOADER_EXPORT___;
